import React from 'react';
import ReactDOM from 'react-dom';
import usePwaInstall from '../../utils/usePwaInstall';
import { promptInstall } from '../../utils/pwaInstall';
import './installAppItem.css';

// "Install App" row for the navbar user dropdown.
//
// Renders nothing when the app is already installed, or when the browser has
// given us no way to install it — an always-visible button that silently does
// nothing on an unsupported browser is worse than no button.
function InstallAppItem({ onDone }) {
  const state = usePwaInstall();
  const [showIosHelp, setShowIosHelp] = React.useState(false);

  if (state === 'installed' || state === 'unavailable') return null;

  const handleClick = async () => {
    if (state === 'ios') {
      setShowIosHelp(true);
      return;
    }
    await promptInstall();
    // Chrome's dialog resolves either way; the menu item disappears on its own
    // via the appinstalled event when the user accepts.
    if (onDone) onDone();
  };

  return (
    <>
      <button className="user-dropdown-item" onClick={handleClick}>
        Install App
      </button>

      {/* Portalled to body: the dropdown unmounts this subtree when it closes,
          and the instructions need to outlive that. */}
      {showIosHelp &&
        ReactDOM.createPortal(
          <div
            className="install-ios-overlay"
            role="dialog"
            aria-modal="true"
            aria-label="Install Artemis"
            onClick={() => setShowIosHelp(false)}
          >
            <div className="install-ios-modal" onClick={(e) => e.stopPropagation()}>
              <h3>Add Artemis to your Home Screen</h3>
              <ol>
                <li>
                  Tap the <span className="install-ios-modal__share">Share</span> button
                  at the bottom of Safari.
                </li>
                <li>Scroll down and tap <strong>Add to Home Screen</strong>.</li>
                <li>Tap <strong>Add</strong>.</li>
              </ol>
              <button
                className="install-ios-modal__close"
                onClick={() => setShowIosHelp(false)}
              >
                Got it
              </button>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}

export default InstallAppItem;
